import { DownloadIcon } from "@chakra-ui/icons";
import { Button, Flex, Text } from "@chakra-ui/react";
import { CustomModal } from "components/custom-modal";
import { ButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";
import { DocumentIcon } from "components/vectors/document-icon";
import { UploadIcon } from "components/vectors/upload-icon";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";

export type ModalOpcoesCorrigirValidacaoParams = {
  onBaixarArquivo?: () => Promise<void>;
  onUploadArquivo?: () => void;
  onCorrigirCSV?: () => Promise<void>;
};

const eventName = "openModalOpcoesCorrigirValidacao";

export const openModalOpcoesCorrigirValidacao =
  createModalTrigger<ModalOpcoesCorrigirValidacaoParams>(eventName);

export function ModalOpcoesCorrigirValidacao() {
  const { isOpen, onClose, params } =
    useModalControls<ModalOpcoesCorrigirValidacaoParams>(eventName);

  const modalFooter = (
    <Flex w="100%" gap="8px" justifyContent="flex-end">
      <ButtonWithLoading
        variant="outline"
        leftIcon={<DownloadIcon />}
        onClick={async () => {
          await params.onBaixarArquivo?.();
          onClose();
        }}
      >
        Baixar CSV
      </ButtonWithLoading>

      <Button
        variant="outline"
        leftIcon={<UploadIcon w="18px" h="18px" />}
        onClick={async () => {
          params.onUploadArquivo?.();
          onClose();
        }}
      >
        Upload de CSV corrigido
      </Button>

      <ButtonWithLoading
        onClick={async () => {
          await params.onCorrigirCSV?.();
          onClose();
        }}
        leftIcon={<DocumentIcon w="18px" h="18px" />}
      >
        Corrigir CSV
      </ButtonWithLoading>
    </Flex>
  );

  return (
    <CustomModal
      modalTitle="Corrigir erros de validação"
      isOpen={isOpen}
      onClose={onClose}
      modalFooter={modalFooter}
      size="xl"
    >
      <Text fontWeight="medium">
        Como deseja corrigir os erros de validação?
      </Text>
    </CustomModal>
  );
}
